import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-auth-redirect',
  standalone: true,
  template: '<div style="display: none;"></div>'
})
export class MsalRedirectComponent {
  private readonly router = inject(Router);
  private readonly msalService = inject(MsalService);

  // This component handles the redirect from Azure AD
  // The actual redirect handling is done by MSAL service automatically
  // No initialization logic needed
}


